import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import 'normalize.css'; // move to proper component

import '@/styles/react-sortable-tree/style.css';
import '@/styles/slick-carousel/slick.css';
import 'react-image-lightbox/style.css';
/* eslint-disable global-require */

import '@formatjs/intl-getcanonicallocales/polyfill';
import React, { useEffect, useRef, useState } from 'react';
import { createMemoryHistory } from 'history';
import { setAutoFreeze } from 'immer';
import Head from 'next/head';
import { useRouter } from 'next/router';
import CookieConsent from 'react-cookie-consent';
import { Provider } from 'react-intl-redux';
import ReactModal from 'react-modal';
import { Router, useHistory } from 'react-router-dom';
import { LastLocationProvider } from 'react-router-last-location';
import AuthClient from '@/lib/auth-client';
import * as LocaleUtils from '@/lib/locale';
import { fetchLocaleData } from '@/redux/actions/intl';
import storeCreator from '@/redux/store';
import useOrgConfigs from '@/hooks/useOrgConfigs';
import AppWrapper from '@/components/app';
import { unregister } from '../serviceWorker';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var isBrowser = true;

if (isBrowser) {
  require('intersection-observer');

  require('what-input');

  if (!Intl.PluralRules) {
    import('@formatjs/intl-pluralrules/polyfill');
  }

  if (!Intl.RelativeTimeFormat) {
    import('@formatjs/intl-relativetimeformat/polyfill');
  }
  /* eslint-disable no-underscore-dangle */


  window.__APP_MOUNT_TIME_START = performance.now();
  /* eslint-enable no-underscore-dangle */

  setAutoFreeze(false);
}

var SyncRouterAdapter = function SyncRouterAdapter(_ref) {
  var children = _ref.children;
  var nextRouter = useRouter();
  var history = useHistory();
  useEffect(function () {
    // @ts-ignore
    history.replaceOriginal(nextRouter.asPath);
  }, [nextRouter.asPath]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};

function App(_ref2) {
  var Component = _ref2.Component,
      pageProps = _ref2.pageProps;
  var nextRouter = useRouter();
  var storeRef = useRef(null);
  var historyRef = useRef(null);

  var _useState = useState({
    isMounted: false
  }),
      isMounted = _useState[0].isMounted,
      setState = _useState[1];

  useEffect(function () {
    var locale = LocaleUtils.getLocale();
    var history = createMemoryHistory(); // Workaround for using client-side react-router Redirect components
    // history.push and history.replace is only used inside Redirect
    // all our usages was moved to next-router so this shouldn't conflict
    // @ts-ignore

    history.pushOriginal = history.push;

    history.push = function () {
      // @ts-ignore
      nextRouter.push.apply(nextRouter, arguments);
    }; // @ts-ignore


    history.replaceOriginal = history.replace;

    history.replace = function () {
      // @ts-ignore
      nextRouter.replace.apply(nextRouter, arguments);
    }; // @ts-ignore


    historyRef.current = history;
    fetchLocaleData(locale).then(function (msgs) {
      var initialState = {
        intl: {
          defaultLocale: locale,
          locale: locale,
          messages: msgs[0]
        }
      };
      var store = storeCreator(initialState); // @ts-ignore

      storeRef.current = store;
      AuthClient.setStore(store);
      setState({
        isMounted: true
      });
    });
  }, []);
  var configs = useOrgConfigs();
  useEffect(function () {
    if (isMounted) {
      var root = document.getElementById('app-root'); // Unregister sw manually. SW was disabled during NextJS migration and we
      // need to unregister it first for all users before completely removing

      unregister();

      if (root) {
        ReactModal.setAppElement(root);
      }
    }
  }, [isMounted]);

  if (!isMounted) {
    return null;
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Head, {
      children: /*#__PURE__*/_jsx("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
      })
    }), /*#__PURE__*/_jsx(CookieConsent, {
      style: {
        background: '#000',
        flexWrap: 'nowrap',
        alignItems: 'center'
      },
      buttonText: /*#__PURE__*/_jsxs("svg", {
        fill: "white",
        width: 30,
        height: 20,
        viewBox: "0 0 1024 1024",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M89.631 813.695L813.708 89.618c33.325-33.325 87.355-33.325 120.68 0s33.325 87.355 0 120.68L210.311 934.375c-33.325 33.325-87.355 33.325-120.68 0s-33.325-87.355 0-120.68z"
        }), /*#__PURE__*/_jsx("path", {
          d: "M210.298 89.621l724.077 724.077c33.325 33.325 33.325 87.355 0 120.68s-87.355 33.325-120.68 0L89.618 210.201c-33.325-33.325-33.325-87.355 0-120.68s87.355-33.325 120.68 0z"
        })]
      }),
      buttonStyle: {
        background: 'transparent',
        marginLeft: -20
      },
      children: "We use cookies and similar technologies to run this website and help us understand how you use it."
    }), /*#__PURE__*/_jsx(Provider, {
      store: storeRef.current,
      children: /*#__PURE__*/_jsx(Router, {
        history: historyRef.current,
        children: /*#__PURE__*/_jsx(LastLocationProvider, {
          children: /*#__PURE__*/_jsx(SyncRouterAdapter, {
            children: /*#__PURE__*/_jsx(AppWrapper, {
              children: /*#__PURE__*/_jsx(Component, _objectSpread({}, pageProps))
            })
          })
        })
      })
    })]
  });
}

export default App;